export default __webpack_public_path__ + "static/media/step-3-quiz.6a8850f3.png";